import React from 'react';
import { StyledBanner } from './StyledBanner';
import { useLocation,useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const Banner = ({ bgColor, text, route, copyRoute, black, isDownload, isExternal, isGreenCta }) => {

  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
    
  }
  return (
    <React.Fragment>
      {
       
          <StyledBanner
            bgColor={bgColor}
          >
            <div className="banner--content">
              <h5 className="big--title" style={{color: black ? black : '#fff'}}>
                {text}
              </h5>
              {
                  isDownload ?
                  <div className="cta--primary cursor-cta">
                    <a className="cursor-cta" href={route} target="_blank">
                      <p className="preset-10 cursor-cta" style={{color: isGreenCta ? '#45B865' : black ? black : '#45B865'}} >{copyRoute}</p>
                      {
                        isExternal ?
                        <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={isGreenCta ? '#45B865' : black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path className="cursor-cta" d="M13 6H1" stroke={isGreenCta ? '#45B865' : black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        :
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path className="cursor-cta" d="M5 13L12 21L19 13" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                          <path className="cursor-cta" d="M12 21V3" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      }
                    </a>
                  </div>
                  :
                  <div className="cta--primary cursor-cta" onClick={()=> handleCLick(route)}>
                    <p className="preset-10 cursor-cta" style={{color: isGreenCta ? '#45B865' : black ? black : '#45B865'}} >{copyRoute}</p>
                      <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={isGreenCta ? '#45B865' : black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path className="cursor-cta" d="M13 6H1" stroke={isGreenCta ? '#45B865' : black ? black : '#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                  </div>
              }

              
            </div>
            
          </StyledBanner>
          
      }
    </React.Fragment>
  );
};

Banner.propTypes = {};

Banner.defaultProps = {
  tag: "div",
  bgColor: "#1A1A1A"
};

export default Banner;
